import {
  and,
  categorizationHasCategory,
  hasType,
  isAllOfControl,
  isAnyOfControl,
  isBooleanControl,
  isDateControl,
  isDateTimeControl,
  isEnumControl,
  isIntegerControl,
  isNumberControl,
  isObjectArrayControl,
  isObjectArrayWithNesting,
  isObjectControl,
  isOneOfControl,
  isOneOfEnumControl,
  isPrimitiveArrayControl,
  isRangeControl,
  isStringControl,
  isTimeControl,
  optionIs,
  or,
  schemaMatches,
  schemaSubPathMatches,
  uiTypeIs,
} from '@jsonforms/core';
import { isSingleLevelCategorization } from '@components/uploadForm/helpers/isSingleLevelCategorization';
import { simpleAnyOf } from '@components/uploadForm/helpers/simpleAnyOf';
import {
  groupTester,
  hasEnumItems,
  hasOneOfItems,
} from '@components/uploadForm/helpers/helpers';
import { ControlConfigurationRendererTester } from '@components/uploadForm/Types/ControlConfiguration';

export const controlConfigurationsTesterRenderer: ControlConfigurationRendererTester[] =
  [
    {
      controlFunc: or(isObjectArrayControl, isPrimitiveArrayControl),
      rank: 3,
      renderer: 'ArrayControlRenderer',
    },
    { controlFunc: isBooleanControl, rank: 2, renderer: 'BooleanControl' },
    {
      controlFunc: and(isBooleanControl, optionIs('toggle', true)),
      rank: 3,
      renderer: 'BooleanToggle',
    },
    {
      rank: 2,
      renderer: 'NativeControl',
      controlFunc: or(isDateControl, isTimeControl),
    },
    {
      rank: 2,
      controlFunc: isEnumControl,
      renderer: 'EnumControl',
    },
    {
      rank: 2,
      controlFunc: isIntegerControl,
      renderer: 'IntegerControl',
    },
    {
      rank: 3,
      controlFunc: isNumberControl,
      renderer: 'NumberControl',
    },
    {
      rank: 1,
      controlFunc: isStringControl,
      renderer: 'TextControl',
    },
    {
      rank: 2,
      controlFunc: isDateTimeControl,
      renderer: 'DateTimeControl',
    },
    {
      rank: 4,
      controlFunc: isDateControl,
      renderer: 'DateControl',
    },
    {
      rank: 4,
      controlFunc: isRangeControl,
      renderer: 'SliderControl',
    },
    {
      rank: 2,
      controlFunc: isObjectControl,
      renderer: 'ObjectRenderer',
    },
    {
      rank: 3,
      controlFunc: isAllOfControl,
      renderer: 'AllOfRenderer',
    },
    {
      rank: 3,
      controlFunc: isAnyOfControl,
      renderer: 'AnyOfRenderer',
    },
    {
      rank: 3,
      controlFunc: isOneOfControl,
      renderer: 'OneOfRenderer',
    },
    {
      rank: 20,
      controlFunc: and(isEnumControl, optionIs('format', 'radio')),
      renderer: 'RadioGroupControl',
    },
    {
      rank: 20,
      controlFunc: and(isOneOfEnumControl, optionIs('format', 'radio')),
      renderer: 'OneOfRadioGroupControl',
    },
    {
      rank: 5,
      controlFunc: isOneOfEnumControl,
      renderer: 'OneOfEnumControl',
    },

    //layouts
    {
      rank: 1,
      controlFunc: groupTester,
      renderer: 'GroupLayout',
      layout: true,
    },
    {
      rank: 2,
      controlFunc: uiTypeIs('HorizontalLayout'),
      renderer: 'HorizontalLayout',
    },
    {
      rank: 1,
      controlFunc: uiTypeIs('VerticalLayout'),
      renderer: 'VerticalLayout',
    },
    {
      rank: 1,
      controlFunc: isSingleLevelCategorization,
      renderer: 'CategorizationLayout',
    },
    {
      rank: 2,
      controlFunc: and(
        uiTypeIs('Categorization'),
        categorizationHasCategory,
        optionIs('variant', 'stepper')
      ),
      renderer: 'MaterialCategorizationStepperLayout',
    },
    {
      rank: 4,
      controlFunc: isObjectArrayWithNesting,
      renderer: 'ArrayLayout',
    },

    //additional
    {
      rank: 1,
      controlFunc: uiTypeIs('Label'),
      renderer: 'LabelRenderer',
    },
    {
      rank: 4,
      controlFunc: uiTypeIs('ListWithDetail'),
      renderer: 'ListWithDetailRenderer',
    },
    {
      rank: 5,
      controlFunc: simpleAnyOf,
      renderer: 'AnyOfStringOrEnumControl',
    },
    {
      rank: 5,
      controlFunc: and(
        uiTypeIs('Control'),
        and(
          schemaMatches(
            schema =>
              !!(
                hasType(schema, 'array') &&
                !Array.isArray(schema.items) &&
                schema.uniqueItems
              )
          ),
          schemaSubPathMatches('items', schema => {
            return hasOneOfItems(schema) || hasEnumItems(schema);
          })
        )
      ),
      renderer: 'EnumArrayRenderer',
    },
    {
      rank: 100,
      controlFunc:
        and(optionIs('otherGroup', true)),
      renderer: 'GroupRenderer',
    }
  ];
